import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";
import {connect, useSelector} from "react-redux";
import {api} from "@redux/api";
import {
    FunctionalTestingColumns,
    functiontestingProps
} from "@containers/facility/Equipment/FunctionalTesting/FunctionalTestingColumns";
import {
    FunctionalTestingFormFields
} from "@containers/facility/Equipment/FunctionalTesting/FunctionalTestingFormFields";
import FunctionTestingEditableTable
    from "@containers/facility/Equipment/FunctionalTesting/FunctionTestingEditableTable";
import { withRouter } from "@/router/withRouter";
import { useAuth, AUTH_LEVEL } from '@/hooks/use-auth';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';
import Select from "@components/ResponsiveSelect";
import { Form } from "antd";
import { FORM_TYPE_OPTIONS } from "@/constants/form-type-options";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";
import { debounce } from "lodash";
import moment from "moment";
import {
    functionalTestingFormTypeLabel,
} from "@containers/facility/Equipment/FunctionalTesting/functionalTestingDisplay";
import "./FunctionalTesting.css";

const FUNCTIONAL_TESTING_MOBILE_EXCLUDE_KEYS = [
    "equipment__name",
    "name",
    "functional_form_name",
    "functional_form__form_type",
    "created_date",
];

const FUNCTIONAL_TESTING_MOBILE_INCLUDE_KEYS = [
    "record_date",
    "record_by",
    "description",
    "createdby_name",
];

const formatMobileDate = (value) => {
    if (value == null || value === "") return "-";
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD HH:mm") : "-";
};

const normalizeMultiValue = (value) => {
    if (Array.isArray(value)) return value.filter((item) => item != null && item !== "");
    if (typeof value === "string") return value.split(",").filter(Boolean);
    if (value == null || value === "") return [];
    return [value];
};

const appendQueryParam = (parts, key, value) => {
    if (Array.isArray(value)) {
        value
            .filter((item) => item != null && item !== "")
            .forEach((item) => appendQueryParam(parts, key, item));
        return;
    }
    if (value == null || value === "") return;
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
};

const renderFunctionalTestingMobileHeader = (record, navigateToFunctionalTestingDetail) => {
    const equipment = record.equipment__name;
    const name = record.name != null ? String(record.name).trim() : "";
    const type = functionalTestingFormTypeLabel(
        record.functional_form__form_type ?? record.functional_form_type
    );
    const templateName =
        record.functional_form_name ||
        (record.functional_form != null && `${record.functional_form}`.trim() !== ""
            ? `#${record.functional_form}`
            : "-");
    const createDate = formatMobileDate(record.created_date);

    const handleTitleClick = (event) => {
        event.stopPropagation();
        navigateToFunctionalTestingDetail(record.id);
    };

    return (
        <div className="functional-testing-mobile-card">
            <div className="functional-testing-mobile-card-main">
                <span className="functional-testing-mobile-card-name-wrap" title={`FormName: ${name}`}>
                    <span className="functional-testing-mobile-card-label">FormName:</span>
                    <span
                        className="functional-testing-mobile-card-title functional-testing-mobile-card-title-link"
                        onClick={handleTitleClick}
                    >
                        {name}
                    </span>
                </span>
                <span className="functional-testing-mobile-card-type" title={`FormType: ${type}`}>
                    <span className="functional-testing-mobile-card-label">FormType:</span>
                    <span className="functional-testing-mobile-card-type-value">{type}</span>
                </span>
                <span className="functional-testing-mobile-card-date">{createDate}</span>
            </div>
            <div className="functional-testing-mobile-card-summary">
                <span className="functional-testing-mobile-card-equipment" title={`Equipment: ${equipment || "-"}`}>
                    {equipment || "-"}
                </span>
                <span className="functional-testing-mobile-card-meta" title={`Template: ${templateName}`}>
                    <span className="functional-testing-mobile-card-meta-label">Template:</span>
                    <span className="functional-testing-mobile-card-meta-value">{templateName}</span>
                </span>
            </div>
        </div>
    );
};

class FunctionalTesting extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            data: [],
            name: '',
            isLoading: false,
            query: null,
            tableRef: null,
            selectedTypeOption: null,
            selectedTemplateType: null,
            formTypeFilter: [],
            equipmentIds: [],
            equipmentOptions: [],
            equipmentLookupLoading: false,
            filterValues: null,
            filterResetKey: 0,
        }
        this.debouncedLoadEquipmentOptions = debounce(this.loadEquipmentOptions, 250);
    }

    handleCreateFunctionalTesting = (body) => {
        console.log('create')
        const equipment_id = this.props.selectedRecord?.id?this.props.selectedRecord?.id:body.equipment__id;
        body['equipment'] = equipment_id;
        return api.createFunctionalTestingView(body).then(
            response => {
                // console.log('create', response);
                this.refresh(false)
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteFunctionalTesting = (id) => {
        return api.deleteFunctionalTestingView(id).then(
            response => {
                this.refresh(false)
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkDelete = (body) => {
        return api.bulkFunctionalTestingView(body).then(
            response => {
                this.refresh(false)
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        row['equipment'] = this.props.selectedRecord?.id?this.props.selectedRecord?.id:row.equipment__id;

        return api.editFunctionalTestingView(key, row).then(
            response => {
                this.refresh(false)
                return response
            }
        ).catch(error => (
            error
        ));
    }


    buildFunctionalTestingQuery = (baseQuery = "", extraParams = {}) => {
        const cleanBaseQuery = String(baseQuery || "").replace(/^\?/, "").replace(/^&/, "");
        const parts = cleanBaseQuery ? [cleanBaseQuery] : [];

        Object.entries(extraParams).forEach(([key, value]) => {
            appendQueryParam(parts, key, value);
        });

        return parts.join("&");
    };

    handleFilter = (query) => {

        this.setState({
            isLoading: true,
        });
        console.log('FunctionalTesting::', this.props.selectedRecord)
        let query_new = this.buildFunctionalTestingQuery(query, {
            equipment_id: this.props.selectedRecord?.id || null,
            equipmentId: !this.props.selectedRecord?.id
                ? normalizeMultiValue(this.state.equipmentIds)
                : [],
            form_type: normalizeMultiValue(this.state.formTypeFilter),
        });

        return api.filterFunctionalTestingView(query_new).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    total: response.data.count,
                    success: true,
                }
            }
        ).catch(error => (
            error
        ));
    }




    getFunctionalTesting = (data) => {

        this.setState({
            isLoading: false,
            data
        })

    }

    refresh = (needRequest) => {
        return this.tableRef?.current?.refresh(needRequest);
    };

    handleSearchSelect = (e, record) => {
        let data = record.record;
        this.setState({
            selectedTypeOption: data?.fields,
            selectedTemplateType: data
        })
    }

    handleFormTypeFilterChange = (value) => {
        const formTypeFilter = normalizeMultiValue(value);
        this.setState({
            formTypeFilter,
            filterValues: {
                ...this.state.filterValues,
                form_type: formTypeFilter,
            },
        }, () => {
            this.refresh(false);
        });
    };

    loadEquipmentOptions = (keyword = "") => {
        this.setState({ equipmentLookupLoading: true });
        return api
            .lookupEquipments(encodeURIComponent(keyword || ""))
            .then((response) => {
                const equipmentOptions = (response.data || []).map((equipment) => ({
                    value: equipment.id,
                    label: equipment.name,
                }));
                this.setState({
                    equipmentOptions,
                    equipmentLookupLoading: false,
                });
                return equipmentOptions;
            })
            .catch((error) => {
                this.setState({ equipmentLookupLoading: false });
                return error;
            });
    };

    handleEquipmentFilterChange = (equipmentIds) => {
        const nextEquipmentIds = normalizeMultiValue(equipmentIds);
        this.setState({
            equipmentIds: nextEquipmentIds,
            filterValues: {
                ...this.state.filterValues,
                equipmentId: nextEquipmentIds,
            },
        }, () => {
            this.refresh(false);
        });
    };

    setFilters = (filterValues) => {
        this.setState({
            filterValues,
        });
    };

    resetFilters = () => {
        this.setState(
            {
                name: '',
                name_keyword: '',
                formTypeFilter: [],
                equipmentIds: [],
                filterValues: null,
                filterResetKey: this.state.filterResetKey + 1,
            },
            () => {
                this.refresh(false);
            }
        );
    };

    renderFilter = () => {
        return (
            <Form
                key={`forms-filter-${this.state.filterResetKey}`}
                className="filter-form"
                autoComplete="off"
                initialValues={{
                    form_type: normalizeMultiValue(this.state.formTypeFilter),
                    equipmentId: normalizeMultiValue(this.state.equipmentIds),
                }}
            >
                <Form.Item label="Form type" name="form_type" style={{ width: "100%" }}>
                    <Select
                        mode="multiple"
                        className="min-multi-selector"
                        style={{ width: "100%" }}
                        placeholder="Form type"
                        allowClear
                        value={normalizeMultiValue(this.state.formTypeFilter)}
                        onChange={this.handleFormTypeFilterChange}
                        options={FORM_TYPE_OPTIONS}
                        optionFilterProp="label"
                    />
                </Form.Item>
                {!this.props.selectedRecord?.id ? (
                    <Form.Item label="Equipment" name="equipmentId" style={{ width: "100%" }}>
                        <Select
                            mode="multiple"
                            className="min-multi-selector"
                            style={{ width: "100%" }}
                            placeholder="Equipment"
                            allowClear
                            showSearch
                            filterOption={false}
                            options={this.state.equipmentOptions}
                            loading={this.state.equipmentLookupLoading}
                            value={normalizeMultiValue(this.state.equipmentIds)}
                            onFocus={() => this.loadEquipmentOptions("")}
                            onSearch={(keyword) => this.debouncedLoadEquipmentOptions(keyword)}
                            onChange={this.handleEquipmentFilterChange}
                        />
                    </Form.Item>
                ) : null}
            </Form>
        );
    };
    gettableRef = (tableRef) => {
        console.log('tableRef', tableRef)
        this.setState({
            tableRef
        })
    }

    onNew = () => {
        this.props.navigate(this.props.createFunctionalTestingPath);
    };

    render() {

        return (

            <div>
                <FunctionTestingEditableTable
                    ref={this.tableRef}
                    columns={FunctionalTestingColumns()}
                    data={this.state.data}
                    columnProps={functiontestingProps}

                    getRecord={this.getFunctionalTesting}
                    createRecords={this.handleCreateFunctionalTesting}
                    deleteRecord={this.handleDeleteFunctionalTesting}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    postComment={this.handlePostComment}
                    renderFilter={this.renderFilter}
                    hide_search={false}
                    isRowClickable={false}
                    isRelated={false}
                    isAttachments={false}
                    setFilters={this.setFilters}
                    resetFilters={this.resetFilters}
                    filterValues={this.state.filterValues}
                    filterDescription={this.state.filterDescription}
                    getFormRef={this.gettableRef}
                    hide_imports={true}
                    formClassName={'flex-form grid grid-cols-4 '}
                    selectedRecord={this.props.selectedRecord}
                    new_text={'Create Form'}
                    onNew={this.onNew}
                    hid_new={!this.props.canWrite}
                    hideMobileTableExpand={true}
                    mobileCardHeaderRender={(record) => renderFunctionalTestingMobileHeader(record, this.props.navigateToFunctionalTestingDetail)}
                    mobileExpandedExcludeKeys={FUNCTIONAL_TESTING_MOBILE_EXCLUDE_KEYS}
                    mobileExpandedIncludeKeys={FUNCTIONAL_TESTING_MOBILE_INCLUDE_KEYS}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {}
}
const mapDispatchToProps = dispatch => {
    return {

    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const canWrite = useAuth('functiontesting', AUTH_LEVEL.WRITE);
        const facilityContext = useSelector((state) => getFacilityContext(state));
        const createFunctionalTestingPath = buildFacilityPath('create-functional-testing', facilityContext) || '/switch-view';
        const { navigateToFunctionalTestingDetail } = useSmartNavigate();
        return (
            <Component
                {...props}
                canWrite={canWrite}
                createFunctionalTestingPath={createFunctionalTestingPath}
                navigateToFunctionalTestingDetail={navigateToFunctionalTestingDetail}
            />
        );
    }
    return NewComponent;
}

export default withHooks(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FunctionalTesting)));
